import React from "react";
import "./LeadsCounter.css";
const LeadsCounter = (props) => {
  const { allLeads, myLeads, reservedLeads, convertedLeads , availableLeads} = props;
  let availableLeadss = +myLeads + +reservedLeads;
  var result = +allLeads - +availableLeadss;
  result = result - convertedLeads;
  return (
    <div className="row">
      <div className="col-md-4">
        <div class="card-counter allLeads">
          <i class="fa fa-arrow-circle-right"></i>
          <span class="count-numbers">{allLeads}</span>
          <span class="count-name">All Leads</span>
        </div>
      </div>
      <div className="col-md-4">
        <div class="card-counter availableLeads">
          <i class="fa fa-ticket"></i>
          <span class="count-numbers">{availableLeads.availableLeadsCount}</span>
          <span class="count-name">Available Leads</span>
        </div>
      </div>
      <div className="col-md-4">
        <div class="card-counter myLeads">
          <i class="fas fa-check-circle"></i>
          <span class="count-numbers">{myLeads}</span>
          <span class="count-name">My Leads</span>
        </div>
      </div>
    </div>
  );
};

export default LeadsCounter;
